import { StyleSheet, View } from "react-native";

import { ThemedFeedback } from "./ThemedFeedback";
import type { ThemedFeedbackWidthProps } from "./ThemedFeedback";

type ToastContentProps = {
  text1: string;
  text2: string;
  type: "info" | "error" | "success" | (string & {});
  onClose?: () => void;
  closeButtonLabel?: string;
} & ThemedFeedbackWidthProps;

export const ToastContent = ({
  type,
  text1,
  text2,
  onClose,
  closeButtonLabel,
  fluid,
  maxWidth,
  compact,
}: ToastContentProps) => {
  const widthProps: ThemedFeedbackWidthProps = fluid
    ? { fluid, maxWidth, compact }
    : {};

  return (
    <View
      style={
        fluid
          ? [
              styles.container,
              styles.containerFluid,
              ...(compact ? [styles.containerCompact] : []),
            ]
          : styles.container
      }
    >
      <ThemedFeedback
        type={type}
        title={text1}
        subtitle={text2}
        onClose={onClose}
        closeButtonLabel={closeButtonLabel}
        {...widthProps}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    paddingTop: 60,
  },
  containerFluid: {
    paddingHorizontal: 16,
  },
  containerCompact: {
    paddingTop: 16,
  },
});
